import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import {
    CheckoutAssistantPage,
    CheckPaymentPage,
    HomePage,
    NotFoundPage,
    OrderCompletePage,
    OrderReceiptPage,
    OrderSearchPage,
    OrderStatusPage,
    PaymentScreen,
    TablePage,
} from '@pages'
import { ROUTES } from '@common'
import { NonAuthLayoutWrapper, MainLayout } from '@layouts'

const router = createBrowserRouter([
    {
        path: '/',
        element: <MainLayout />,
        children: [
            // { index: true, element: <HomePage /> },
            { path: ROUTES.Table.root, element: <TablePage /> },
            { path: ROUTES.Order.complete, element: <OrderCompletePage /> },
            { path: ROUTES.Order.number, element: <OrderStatusPage /> },
            { path: ROUTES.Order.search, element: <OrderSearchPage /> },
            { path: ROUTES.Order.receipt, element: <OrderReceiptPage /> },
            { path: ROUTES.Payment.root, element: <PaymentScreen /> },
            { path: ROUTES.Payment.check, element: <CheckPaymentPage /> },
            { path: ROUTES.CheckoutAssistant.root, element: <CheckoutAssistantPage /> },
            { path: 'not-fount', element: <NotFoundPage /> },
        ],
    },
    {
        path: '/',
        element: <NonAuthLayoutWrapper />,
        children: [{ index: true, element: <HomePage /> }],
    },
    {
        path: '*',
        element: <NotFoundPage />,
    },
])

export default function AppRoutes() {
    return <RouterProvider router={router} />
}
